module.exports = __webpack_public_path__ + "img/cm.47730c27.svg";